import script from "./TrainersList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainersList.vue?vue&type=script&setup=true&lang=js"

import "./TrainersList.vue?vue&type=style&index=0&id=511006bf&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511006bf"]])

export default __exports__